module.exports = __webpack_public_path__ + "static/media/profile-pic.b0b9219a.png";